import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

// Login API
export const login = async (loginData) => {
  try {
    const res = await api.login_api(loginData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// Logout API
export const logout = async () => {
  try {
    const res = await api.logout_api();
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// verify otp
export const verifyOTP = async (bodyData) => {
  try {
    const res = await api.verify_otp(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

// resend otp
export const resendOTP = async (bodyData) => {
  try {
    const res = await api.resend_otp(bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const setPassword = async (passwordData) => {
  try {
    const res = await api.set_password(passwordData);
    return res.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};
export const changePassword = async (bodyData) => {
  try {
    const res = await api.change_password(bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
